import { Injectable, inject } from '@angular/core';
import { environment } from '@env/environment';
import { BaseParamsService } from '../../base-params.service';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { EMPTY, Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { LoggerService } from '@app/core/logger.service';

@Injectable({
  providedIn: 'root',
})
export class AutologinService {
  private http = inject(HttpClient);
  private baseParamsService = inject(BaseParamsService);
  private logger = inject(LoggerService);


  public updateCookieTracking(status: boolean): Observable<unknown> {
    return this.http.post(
      this.url(),
      { status: status },
      { headers: this.baseParamsService.getAuthHeadersWithAutologin(false) || new HttpHeaders() },
    ).pipe(
      catchError((error) => {
        if (error instanceof HttpErrorResponse && error.status === 422) {
          this.logger.logError(new Error('422 on autologins/update_cookie_tracking'), {
            status,
            response: error.error,
          });
          return EMPTY;
        }
        return throwError(() => error);
      }),
    );
  }

  private url(): string {
    return `${environment.webforms_api}/v2/${this.baseParamsService.slug}/autologins/update_cookie_tracking`;
  }
}
